import React, {useCallback, useMemo} from "react";
import {gql} from "@apollo/client";
import {useTranslation} from "react-i18next";
import {Project} from "../../../schema";

import {useTour} from "../../../providers/tour";
import {isEditorIndexTourMock} from "../../../scenes/editor/index.tour";

import EditItemDropdown from "../../EditItemDropdown";

type props = {
  project: Pick<Project, "id">,
  disabled?: boolean,
  onCopy: (projectId: Project["id"]) => void,
  onDelete: (projectId: Project["id"]) => void
}

export default function ProjectEditDropdown({project, disabled, onCopy, onDelete, ...props}: props) {
  const {t} = useTranslation();

  const {mock: tourMock} = useTour();

  const mock = useMemo(() => {
    if (isEditorIndexTourMock(tourMock)) {
      return tourMock.getBy.project.get(project.id);
    }
  }, [project, tourMock]);
  const onDropdownClick = mock?.eventHandlers.dropdownClick;

  const onRefClick = useCallback(() => {
    onDropdownClick && setTimeout(onDropdownClick);
  }, [onDropdownClick]);

  const copyHandler = useCallback(() => {
    onCopy && onCopy(project.id);
  }, [onCopy, project.id]);

  const deleteHandler = useCallback(() => {
    onDelete && onDelete(project.id);
  }, [onDelete, project.id]);

  return (
    <EditItemDropdown
      className={mock?.classes.dropdownContent}
      buttonClassName={mock?.classes.dropdown}
      onRefClick={onRefClick}
    >
      <EditItemDropdown.Action title={t("common.copy")} onClick={copyHandler} disabled={disabled}/>
      <EditItemDropdown.Action title={t("common.delete")} onClick={deleteHandler} disabled={disabled}/>
    </EditItemDropdown>
  )
}

ProjectEditDropdown.fragments = {
  root: gql`
    fragment ProjectEditDropdown on Project {
      id
    }
  `
}
